module.exports = __webpack_public_path__ + "img/7.0e0e0f48.png";